import React from 'react';
export function Footer() {
  return <footer className="w-full bg-cream py-10" data-id="element-60" data-mp="32wmotssah8ty">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-61" data-mp="3gfsoch60l2p3">
        <span className="font-display text-lg font-black text-green-deep" data-id="element-62" data-mp="3ghc508vl1fre">
          Momento Vianda 🍎
        </span>
        <p className="mt-3 text-sm leading-relaxed text-[#8A9182]" data-id="element-63" data-mp="36pfu1x8edv5r">
          Producto digital. El acceso se entrega de forma inmediata tras la compra.
          Los resultados pueden variar según cada familia.
        </p>
        <p className="mt-4 text-xs text-[#A8AFA0]" data-id="element-64" data-mp="398y6cw8527j">
          © {new Date().getFullYear()} Momento Vianda. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}